import Popup from '@jetbrains/ring-ui/components/popup/popup'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import React from 'react'

import {useAppSelector} from '../../../../../../hooks/react-redux'
import {hasPipelineErrors} from '../../../EditPipelinePage/EditPipelinePage.selectors'

import type {PopupErrorProps} from './PopupError.types'

import styles from './PopupError.css'

function PopupError({children, className, error, ...restProps}: PopupErrorProps) {
  const hasErrors = useAppSelector(hasPipelineErrors)
  const isError = hasErrors && error

  return (
    <div className={className}>
      {children}
      {isError && (
        <Popup
          trapFocus={false}
          hidden={false}
          attached={false}
          offset={10}
          autoPositioning
          autoPositioningOnScroll
          className={styles.errorBubblePopup}
          directions={[Directions.LEFT_CENTER]}
          {...restProps}
        >
          <div className={styles.errorBubble}>{error}</div>
        </Popup>
      )}
    </div>
  )
}

export default PopupError
